module.exports = __webpack_public_path__ + "static/media/solar-panel.6f07e7b9.svg";